module.exports = __webpack_public_path__ + "img/shoulder-endo-mesomorph-female.81a252b2.svg";